import apiService from '../apiService';
import { fetchAllPaginatedList } from '@/utils/paginatedFetch';

const RANKS_URL = '/api/admin/ranks';
const RANK_PAGE_SIZE = 100;

/**
 * 獲取聘階列表（分頁）
 * @param {Object} params - 查詢參數
 * @returns {Promise} API 響應
 */
export const getRanks = async (params = {}) => {
    const safeParams = { ...params };
    if (Number(safeParams.per_page) > RANK_PAGE_SIZE) {
        safeParams.per_page = RANK_PAGE_SIZE;
    }
    return apiService.GET(RANKS_URL, safeParams);
};

/**
 * 取得所有聘階（自動翻頁合併，供下拉選單使用）
 */
export const fetchAllRankRows = async (params = {}) => {
    return fetchAllPaginatedList(
        ({ page, per_page }) => getRanks({ ...params, page, per_page }),
        RANK_PAGE_SIZE
    );
};

/**
 * @param {Array} rows
 * @param {{ valueAsString?: boolean }} options
 */
export const toRankOptions = (rows, { valueAsString = false } = {}) =>
    (Array.isArray(rows) ? rows : []).map((rank) => ({
        label: rank.name,
        value: valueAsString ? String(rank.id) : rank.id
    }));

/**
 * 獲取單一聘階詳情
 * @param {number} rankId - 聘階 ID
 * @returns {Promise} API 響應
 */
export const getRankDetail = async (rankId) => {
    const url = `/api/admin/ranks/${rankId}`;
    return apiService.GET(url);
};

/**
 * 更新聘階
 * @param {number} rankId - 聘階 ID
 * @param {Object} data - 聘階資料
 * @returns {Promise} API 響應
 */
export const updateRank = async (rankId, data) => {
    const url = `/api/admin/ranks/${rankId}`;
    return apiService.PUT(url, data);
};

/**
 * 刪除聘階
 * @param {number} rankId - 聘階 ID
 * @returns {Promise} API 響應
 */
export const deleteRank = async (rankId) => {
    const url = `/api/admin/ranks/${rankId}`;
    return apiService.DELETE(url);
};

/**
 * 創建聘階
 * @param {Object} data - 聘階資料
 * @returns {Promise} API 響應
 */
export const createRank = async (data) => {
    const url = '/api/admin/ranks';
    return apiService.POST(url, data);
};

/**
 * 交換聘階順序
 * @param {number} firstRankId - 第一個聘階 ID
 * @param {number} secondRankId - 第二個聘階 ID
 * @returns {Promise} API 響應
 */
export const swapRanks = async (firstRankId, secondRankId) => {
    const url = '/api/admin/ranks/swap';
    return apiService.POST(url, {
        first_rank_id: firstRankId,
        second_rank_id: secondRankId
    });
};

/**
 * 獲取用戶聘階歷史記錄
 * @param {number} userId - 用戶 ID
 * @returns {Promise} API 響應
 */
export const getUserRankHistory = async (userId) => {
    const url = `/api/admin/user/${userId}/ranks/history`;
    return apiService.GET(url);
};
